import { getAxiosBackendApi } from "../helpers/axios"

class InjuredServices{

    constructor(){
    }

    addInjured(data){
        return getAxiosBackendApi().post('woundeds', data)
    }
}

export default new InjuredServices()